const isHotdeal = window.productPage.isHotDeal || false
const isGiftCard = window.productPage.isGiftCard
const isCustomProduct = !!window.custom_template

const state = {
  cartDisabled: true,
  imgIndex: 0,
  variant: null,
  type: null,
  layout: null,
  size: null,
  depth: null,
  amount: null,
  color: null,
  frameColor: ''
}

export { state, isGiftCard, isCustomProduct, isHotdeal }
